import React from 'react';
import AccountingCycleBreadcrumbs from '../shared/AccountingCycleBreadcrumbs';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import { useAccountingCycleUrl } from '../shared/useAccountingCycleRouting';

const AccountingCycleBreadcrumbsItem = ({ children }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const { getSingleEntityUrl } = useAccountingCycleUrl();
  const id = data?.getValueBySource('id');

  return (
    <AccountingCycleBreadcrumbs>
      <SingleBreadcrumbItem entity="Accounting Cycle" link={getSingleEntityUrl(id)} />
      {children}
    </AccountingCycleBreadcrumbs>
  );
};

export default AccountingCycleBreadcrumbsItem;
